// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2ANwz","tab":"ProcedureTabs_tab__3OrGU"};